import React from 'react';

function Icon(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 -960 960 960">
      <path
        fill={props.fill || '#1D252D'}
        d="M450.231-130.001v-83.692Q398.001-223 360.27-254.5t-55.731-88.115l55.537-23.076q16.154 46.461 46.039 71.076 29.885 24.616 79.808 24.616 43.308 0 76.423-20.616Q595.462-311.23 595.462-356q0-38.846-24.885-62.039-24.884-23.192-102.961-48.423-81.769-25.846-113.577-60.461-31.808-34.616-31.808-87.077 0-60.384 42.385-95.038 42.385-34.654 85.615-38.5v-82.461h59.999v82.461q45.769 6.077 76.923 29.769 31.153 23.692 48.461 61.615l-54.768 25.076q-13.153-28.923-36.692-44.923-23.539-16-61.923-16-45.154 0-72.578 22Q382.23-648 382.23-614q0 34.923 28.077 55.846 28.077 20.924 104.384 43.847 70.924 21.538 105.847 61.384 34.923 39.846 34.923 95.692 0 65.615-42.193 101.846-42.192 36.231-103.038 42.923v82.461h-59.999z"
      ></path>
    </svg>
  );
}

export default Icon;
